/* eslint-disable */
import * as React from "react";
import OrbitIcon from "../Icon";
export default function InformationCircle(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(OrbitIcon, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M14.167 17h-3.334c-.5 0-.833-.315-.833-.786 0-.472.333-.787.833-.787h.667c.083 0 .167-.079.167-.157v-3.54c0-.078-.084-.157-.167-.157h-.667c-.5 0-.833-.315-.833-.786s.333-.787.833-.787h.834c.916 0 1.666.708 1.666 1.573v3.775c0 .079.084.158.167.158h.667c.5 0 .833.314.833.786 0 .472-.333.708-.833.708zM12.3 6c.693 0 1.3.607 1.3 1.3s-.52 1.3-1.3 1.3S11 7.993 11 7.3 11.607 6 12.3 6zM12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2"
  }));
}